import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormField,MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect,MatSelectModule } from '@angular/material/select';
import { forkJoin as observableForkJoin } from 'rxjs';

import { Location } from '@angular/common';
import { Component,Inject,Input,OnInit } from '@angular/core';
import {
FormBuilder,
FormControl,
FormGroup,
Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { map,startWith } from 'rxjs/operators';

import { MatInput,MatInputModule } from '@angular/material/input';
import { ToastrService } from 'ngx-toastr';
import {
LogServiceToken,
MapperServiceToken,
RepositoryServiceToken,
} from '../../services';
import {
ILogService,
IMapperService,
IRepositoryService,
} from '../../services/i';
import { priorities,receivedThrough,states } from '../../static-data';
import {
CategoryViewModel,
ContactDetailViewModel,
CorrespondenceCategoryViewModel,
CorrespondenceViewModel,
RequestorCorrespondenceViewModel,
RequestorViewModel,
CorrespondenceViewModel as VMCorr,
} from '../../view-models';
import { BaseFilterViewModel as CorFilter } from '../../view-models/filters';
import { IFilterViewModel } from '../../view-models/filters/i';
import { HeaderComponent } from '../header/header.component';
import { AfterTodayValidator,BeforeTomorrowValidator } from './validators';

@Component({
  selector: 'app-add-correspondence',
  templateUrl: './add-correspondence.component.html',
  styleUrls: ['./add-correspondence.component.css'],
  imports: [
    HeaderComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatFormField,
    MatSelectModule,
    MatSelect,
    MatInputModule,
    MatInput,
    MatButtonModule,
  ],
  standalone: true,
})
export class AddCorrespondenceComponent implements OnInit {
  submitAttempted = false;
  submitting = false;
  submitError = '';
  correspondences: VMCorr[] = [];
  categories: CategoryViewModel[] = [];
  correspondenceCategories: CorrespondenceCategoryViewModel[] = [];
  filter: IFilterViewModel = new CorFilter();
  @Input() correspCat: FormControl = new FormControl();
  filteredReceivedThrough: any;
  receivedThroughCommon: string[] = [
    'Email',
    'Phone',
    'Text Message',
    'Mail',
    'In-Person',
  ];
  priorities: string[] = priorities;
  // correspCat: FormControl = new FormControl();
  public myForm: FormGroup;
  states: string[] = states;
  receivedThrough: string[] = receivedThrough;
  cvm: CorrespondenceViewModel;
  //  http:// blog.angular-university.io/introduction-to-angular-2-forms-template-driven-vs-model-driven/
  //  Regarding subscribe and emit: https:// scotch.io/tutorials/angular-2-http-requests-with-observables
  //  Automapper (if really necessary): https:// github.com/loedeman/AutoMapper/wiki
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private location: Location,
    @Inject(MapperServiceToken) private mapper: IMapperService,
    @Inject(RepositoryServiceToken) private repo: IRepositoryService,
    @Inject(LogServiceToken) private log: ILogService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // this.repo.Page(CategoryViewModel, this.filter).subscribe(cats => this.categories = cats);
    this.myForm = this.fb.group(
      {
        Type: ['', Validators.required],
        NewRequestor: this.fb.group({
          FirstName: [''],
          MiddleName: [''],
          LastName: [''],
          Details: [''],
          Address: [''],
          City: [''],
          State: [''],
          Zip: [''],
          Phone: [''],
          Email: [''],
        }),
        Priority: ['Normal', Validators.required],
        Title: ['', Validators.required],
        Category: ['', Validators.required],
        Summary: [''],
        Notes: [''],
        ReceivedThrough: ['Postal Mail'],
        DateReceived: [
          moment().format('YYYY-MM-DD'),
          [new BeforeTomorrowValidator()],
        ],
        DueDate: [moment().format('YYYY-MM-DD'), [new AfterTodayValidator()]],
      },
      {
        validator: group => {
          return group.value.Type === 'Incoming' &&
            !(
              group.value.DateReceived &&
              group.value.DueDate &&
              group.value.ReceivedThrough
            )
            ? { datesRequired: true }
            : null;
        },
      }
    );

    this.filteredReceivedThrough = this.myForm.controls[
      'ReceivedThrough'
    ].valueChanges.pipe(
      startWith(null),
      map(r =>
        r
          ? this.receivedThroughCommon.filter(c => c.indexOf(r) >= 0)
          : this.receivedThroughCommon
      )
    );

    const filter = new CorFilter();
    filter.PageSize = 30;
    this.repo
      .Page(CategoryViewModel, filter)
      .subscribe(cats => (this.categories = cats));
  }

  goBack() {
    this.location.back();
  }

  onsubmit(): void {
    if (this.submitting) {
      return;
    }

    this.submitAttempted = true;
    this.submitError = '';
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched();
      this.log.debug(this.myForm.errors, this.myForm);
      return;
    }

    const value = this.myForm.value;
    const ci = this.mapper.MapJsonToVM(
      CorrespondenceViewModel,
      {
        Type: value.Type,
        Priority: value.Priority,
        Title: value.Title,
        Summary: value.Summary,
        Notes: value.Notes,
        ReceivedThrough: value.ReceivedThrough,
        DateReceived: value.DateReceived,
        DueDate: value.DueDate,
      }
    );
    ci.Id = 0;
    ci.Status = 'Intake';

    this.submitting = true;
    this.repo
      .Create(CorrespondenceViewModel, ci)
      .toPromise()
      .then(this.onCreate.bind(this))
      .catch(e => this.handleSubmitError(e));
  }

  onCreate(v: VMCorr) {
    const ccms: CorrespondenceCategoryViewModel[] = [];

    for (const u of this.myForm.value.Category) {
      const ccm = new CorrespondenceCategoryViewModel();
      ccm.Id = 0;
      ccm.CorrespondenceId = v.Id;
      ccm.CategoryId = u;
      ccms.push(ccm);
    }
    this.repo
      .CreateMany(CorrespondenceCategoryViewModel, ccms)
      .toPromise()
      .then(() => {
        const contact = new RequestorViewModel();
        const r = this.myForm.value.NewRequestor;
        contact.FirstName = r.FirstName;
        contact.MiddleName = r.MiddleName;
        contact.LastName = r.LastName;
        contact.Notes = r.Details;
        return this.repo.Create(RequestorViewModel, contact).toPromise();
      })
      .then(rvm => {
        const details = new ContactDetailViewModel();
        const r = this.myForm.value.NewRequestor;
        details.RequestorId = rvm.Id;
        details.Address1 = r.Address;
        details.City = r.City;
        details.State = r.State;
        details.PostalCode = r.Zip;
        details.Phone = r.Phone;
        details.Email = r.Email;
        const join = new RequestorCorrespondenceViewModel();
        join.CorrespondenceId = v.Id;
        join.RequestorId = rvm.Id;

        const rdp = this.repo
          .Create(RequestorCorrespondenceViewModel, join)
          .toPromise();
        const cdp = this.repo.Create(ContactDetailViewModel, details).toPromise();
        return observableForkJoin([rdp, cdp]).toPromise();
      })
      .then(
        () => {
          this.submitting = false;
          const message = `Correspondence "${(v.Title || '').substr(0, 20)}" has been created.`;
          this.toastr.success(message);
          this.router.navigate(['/correspondence', v.Id]);
        },
        e => this.handleSubmitError(e)
      );
  }

  private handleSubmitError(error: unknown) {
    this.submitting = false;
    this.submitError = 'Unable to create the correspondence. Please try again.';
    this.log.error(error);
    this.toastr.error(this.submitError);
  }

  showRequiredError(fieldPath: string[]): boolean {
    return this.submitAttempted && this.myForm.hasError('required', fieldPath);
  }

  showCustomError(fieldPath: string[], error: string): boolean {
    return this.submitAttempted && this.myForm.hasError(error, fieldPath);
  }
}
